import React from 'react';
import Card from '@teetsh/app/src/components/Card';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { School } from '@teetsh/app/src/types/school';
import { Schoolyear } from '@teetsh/app/src/types/schoolyear';
import tw from 'twin.macro';

interface Props {
  selected?: boolean;
  schoolyear: Schoolyear;
  school: School;
  classrooms: Classroom[];
  onClick: () => void;
}

interface ItemProps {
  title: string;
  subtitle: string;
  body?: string;
  selected?: boolean;
}

function Item({ title, subtitle, body, selected }: ItemProps) {
  return (
    <div tw="flex justify-between">
      <div>
        <div css={[selected && tw`text-primary`, tw`font-medium truncate`]}>
          {title}
        </div>
        {body && (
          <p
            css={[
              selected && tw`text-brand-intense`,
              !selected && tw`text-muted`,
              tw`text-sm`,
            ]}
          >
            {body}
          </p>
        )}
      </div>
      <div
        css={[
          selected && tw`text-brand-intense`,
          !selected && tw`text-muted`,
          tw`text-sm`,
        ]}
      >
        {subtitle}
      </div>
    </div>
  );
}

export function ItemCard(props: Props) {
  const { classrooms, school, schoolyear, onClick, selected = false } = props;
  return (
    <Card
      css={[
        tw`p-4! h-full`,
        selected &&
          tw`bg-brand-moderate bg-opacity-20 border-primary hover:border-primary`,
      ]}
      interactive
      onClick={onClick}
    >
      <Item
        selected={selected}
        title={school.name}
        subtitle={schoolyear.label}
        body={classrooms.map(c => c.name).join(' · ')}
      />
    </Card>
  );
}
